// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"ArticleTitle_articleTitle__L0DkT"};